export const MAKE_TO_COUNTRY: Record<string, string> = {
  Honda: 'Japan', Acura: 'Japan', Toyota: 'Japan', Lexus: 'Japan',
  Mazda: 'Japan', Subaru: 'Japan', Nissan: 'Japan', Infiniti: 'Japan',
  Mitsubishi: 'Japan', Suzuki: 'Japan', Scion: 'Japan', Datsun: 'Japan',
  BMW: 'Germany', Mercedes: 'Germany', 'Mercedes-Benz': 'Germany',
  'Mercedes Benz': 'Germany', 'Mercedes-AMG': 'Germany', AMG: 'Germany',
  Audi: 'Germany', Porsche: 'Germany',
  Volkswagen: 'Germany', VW: 'Germany', MINI: 'Germany', Mini: 'Germany',
  Ford: 'USA', Chevrolet: 'USA', Chevy: 'USA', Dodge: 'USA',
  Cadillac: 'USA', GMC: 'USA', RAM: 'USA', Tesla: 'USA',
  Corvette: 'USA', Lincoln: 'USA', Jeep: 'USA', Chrysler: 'USA',
  Lucid: 'USA', Rossion: 'USA',
  Hyundai: 'South Korea', Kia: 'South Korea', Genesis: 'South Korea',
  Jaguar: 'UK', 'Land Rover': 'UK', 'Aston Martin': 'UK',
  McLaren: 'UK', Lotus: 'UK', Bentley: 'UK', 'Rolls-Royce': 'UK',
  TVR: 'UK', Morgan: 'UK', Caterham: 'UK', Ariel: 'UK',
  Aston: 'UK',
  Volvo: 'Sweden', Polestar: 'Sweden', Koenigsegg: 'Sweden',
  Ferrari: 'Italy', Lamborghini: 'Italy', Maserati: 'Italy',
  'Alfa Romeo': 'Italy', Fiat: 'Italy', Abarth: 'Italy', Pagani: 'Italy',
  Renault: 'France', Peugeot: 'France', Alpine: 'France', Bugatti: 'France',
  BYD: 'China', Geely: 'China', NIO: 'China', Xiaomi: 'China',
};

export const COUNTRY_FLAG: Record<string, string> = {
  Japan: '\u{1F1EF}\u{1F1F5}',
  'South Korea': '\u{1F1F0}\u{1F1F7}',
  USA: '\u{1F1FA}\u{1F1F8}',
  Germany: '\u{1F1E9}\u{1F1EA}',
  UK: '\u{1F1EC}\u{1F1E7}',
  Sweden: '\u{1F1F8}\u{1F1EA}',
  Italy: '\u{1F1EE}\u{1F1F9}',
  France: '\u{1F1EB}\u{1F1F7}',
  China: '\u{1F1E8}\u{1F1F3}',
};
